module.exports = __webpack_public_path__ + "img/web-p2-f1.055c41f1.svg";